"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _menuOptionsContainer = _interopRequireDefault(require("../../utils/common-portal/menu-options-container"));

var _constants = require("./constants");

var _pill = _interopRequireDefault(require("../pill"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _fi = require("react-icons/fi");

var _io = require("react-icons/io5");

var _helperUtils = require("../../utils/helper-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-autocomplete-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: fit-content; }\n\n.bds-autocomplete-container {\n  background-color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  border: 0.0625rem solid #8d8d8d;\n  border-radius: 0.125rem;\n  padding-top: 0.9375rem;\n  padding-left: 1rem;\n  box-sizing: border-box;\n  align-items: center; }\n\n.bds-autocomplete-single-select-container {\n  background-color: #ffffff;\n  border: 0.0625rem solid #8d8d8d;\n  border-radius: 0.125rem;\n  padding: 0.4375rem 0.9375rem; }\n\n.bds-autocomplete-container-focus:focus-within {\n  border: 0.125rem solid #067fdb;\n  padding-top: 0.875rem;\n  padding-left: 0.9375rem; }\n\n.bds-autocomplete-container-focus .bds-pill-wrapper {\n  padding-bottom: 0.875rem; }\n\n.bds-autocomplete-container-focus .bds-input {\n  margin-bottom: 0.8125rem; }\n\n.bds-autocomplete-container-error {\n  border: 0.125rem solid #da1e28;\n  padding-top: 0.875rem;\n  padding-left: 0.9375rem; }\n\n.bds-autocomplete-single-select-container-focus:focus-within {\n  border: 0.125rem solid #067fdb;\n  padding: 0.375rem 0.875rem; }\n\n.bds-autocomplete-single-select-container-error {\n  border: 0.125rem solid #da1e28;\n  padding: 0.375rem 0.875rem; }\n\n.bds-autocomplete-container-disabled {\n  border: 0.0625rem solid #c6c6c6; }\n\n.bds-autocomplete-container-read-only {\n  border: none;\n  padding: 0rem; }\n\n.bds-actions-container {\n  display: flex; }\n\n.bds-actions-multiple-input-container {\n  padding-top: 0.3125rem; }\n\n.bds-actions-container-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  cursor: pointer;\n  margin-bottom: 1.25rem;\n  margin-right: 1rem;\n  height: 16px;\n  margin-top: -2px; }\n\n.bds-autocomplete-actions-container-disabled-item {\n  cursor: default; }\n\n.bds-single-select-actions-container-item {\n  margin-bottom: 0rem;\n  margin-right: 0rem;\n  margin-left: 1rem; }\n\n.bds-autocomplete-label {\n  height: 1.1875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #393939;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600; }\n\n.bds-autocomplete-label-disabled {\n  color: #c6c6c6; }\n\n.bds-autocomplete-helper-text {\n  height: 1.0625rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #6f6f6f;\n  font-size: 0.75rem;\n  margin-bottom: 0.25rem; }\n\n.bds-autocomplete-helper-text-disabled {\n  color: #c6c6c6; }\n\n.bds-pills-input-wrapper {\n  margin-right: 1rem;\n  display: flex;\n  flex-wrap: wrap; }\n\n.bds-autocomplete-single-select-input-wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center; }\n\n.bds-pill-wrapper {\n  display: inline-block;\n  padding-right: 1rem;\n  padding-bottom: 0.9375rem; }\n\n.bds-autocomplete-input {\n  border: none;\n  height: 2rem;\n  padding: 0rem;\n  margin-bottom: 0.875rem;\n  margin-right: 1rem;\n  color: #393939;\n  font-size: 0.875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  text-align: left;\n  flex-grow: 1; }\n  .bds-autocomplete-input:focus {\n    outline: none; }\n  .bds-autocomplete-input::-webkit-input-placeholder {\n    color: #8d8d8d;\n    font-size: 0.875rem;\n    font-family: \"OpenSansRegular\"; }\n  .bds-autocomplete-input::-moz-placeholder {\n    color: #8d8d8d;\n    font-size: 0.875rem;\n    font-family: \"OpenSansRegular\"; }\n\n.bds-autocomplete-single-select-input {\n  width: 100%;\n  height: 1.1875rem;\n  margin: 0rem; }\n\n.bds-autocomplete-single-select-disabled-input {\n  color: #c6c6c6;\n  background: #ffffff !important; }\n\n.bds-autocomplete-single-select-read-only {\n  text-align: left;\n  font-size: 0.875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #525252; }\n\n.bds-autocomplete-error-message {\n  text-align: left;\n  font-size: 0.75rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  margin-top: 0.0625rem;\n  color: #da1e28; }\n\n.bds-autocomplete-icon {\n  color: #6f6f6f; }\n\n.bds-autocomplete-icon-disabled {\n  color: #c6c6c6; }\n";
  var fileName = "compone_autocomplete";
  var element = document.querySelector("style[data-sass-component='compone_autocomplete']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Autocomplete = function Autocomplete(_ref) {
  var _labelClasses, _helperTextClasses, _containerClasses, _inputClasses, _actionsContainerItem, _pillInputWrapperClas;

  var options = _ref.options,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      label = _ref.label,
      helperText = _ref.helperText,
      onInputChange = _ref.onInputChange,
      onChange = _ref.onChange,
      getOptionLabel = _ref.getOptionLabel,
      getOptionSublabel = _ref.getOptionSublabel,
      getOptionIcon = _ref.getOptionIcon,
      value = _ref.value,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      width = _ref.width,
      errorMessage = _ref.errorMessage,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? _constants.defaultPlaceholder : _ref$placeholder,
      name = _ref.name,
      _onBlur = _ref.onBlur,
      error = _ref.error,
      _ref$disablePortal = _ref.disablePortal,
      disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
      _ref$allowClearing = _ref.allowClearing,
      allowClearing = _ref$allowClearing === void 0 ? true : _ref$allowClearing,
      height = _ref.height,
      _ref$filterCurrentVal = _ref.filterCurrentValueFromOptions,
      filterCurrentValueFromOptions = _ref$filterCurrentVal === void 0 ? false : _ref$filterCurrentVal,
      groupPropertyName = _ref.groupPropertyName,
      _ref$showOptionsOnBlu = _ref.showOptionsOnBlur,
      showOptionsOnBlur = _ref$showOptionsOnBlu === void 0 ? false : _ref$showOptionsOnBlu;
  var selectedValues;
  var filteredOptions;
  (0, _react.useEffect)(function () {
    var inputValue = !multiple && Boolean(value) ? getOptionLabel(selectedValues[0]) : '';
    setInputValue(inputValue || '');
    setSelectedOptions(selectedValues);
  }, [JSON.stringify(value)]);

  var filterSelectedOptionsFromOptions = function filterSelectedOptionsFromOptions(allOptions, selectedOptions) {
    var optionsAfterFilter = _toConsumableArray(allOptions);

    var _iterator = _createForOfIteratorHelper(selectedOptions),
        _step;

    try {
      var _loop = function _loop() {
        var selectedOption = _step.value;
        optionsAfterFilter = optionsAfterFilter.filter(function (item) {
          return !(0, _helperUtils.shallowCompare)(item, selectedOption);
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return optionsAfterFilter;
  };

  selectedValues = Boolean(value) ? _toConsumableArray(value) : [];
  filteredOptions = multiple ? filterSelectedOptionsFromOptions(options, selectedValues) : options;

  var _useState = (0, _react.useState)(!multiple && Boolean(value) ? getOptionLabel(selectedValues[0]) : ''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = (0, _react.useState)(filteredOptions),
      _useState4 = _slicedToArray(_useState3, 2),
      filteredSuggestions = _useState4[0],
      setFilteredSuggestions = _useState4[1];

  var _useState5 = (0, _react.useState)(selectedValues),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedOptions = _useState6[0],
      setSelectedOptions = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showOptions = _useState8[0],
      setShowOptions = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = _slicedToArray(_useState9, 2),
      containerDimension = _useState10[0],
      setContainerDimension = _useState10[1];

  var autocompleteRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    setFilteredSuggestions(multiple ? filterSelectedOptionsFromOptions(options, selectedValues) : options);
  }, [JSON.stringify(options)]);

  var getContainerDimension = function getContainerDimension() {
    var rect = autocompleteRef.current.getBoundingClientRect();
    var dimension = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      height: rect.height
    };
    setContainerDimension(dimension);
  };

  var blurHandler = function blurHandler(event) {
    var isOptionCorrect = false;

    for (var i in options) {
      if (getOptionLabel(options[i]) === inputValue) isOptionCorrect = true;
    }

    if (showOptionsOnBlur) {
      /**
       * Show the options list only if the following conditions are true:
       * 1. The list is already open.
       * 2. There is some text input by the user.
       * 3. The text input doesn't matches any of the available options.
       */
      if (showOptions && inputValue && !isOptionCorrect) {
        setShowOptions(true);
      } else {
        setShowOptions(false);
      }

      return;
    }

    if (!multiple && !isOptionCorrect) {
      setInputValue('');
      setFilteredSuggestions(options);
    }

    if (multiple) {
      setInputValue('');
      setFilteredSuggestions(filterSelectedOptionsFromOptions(options, selectedOptions));
    }

    setShowOptions(false);
    !isOptionCorrect && typeof onInputChange === 'function' && onInputChange(event, '');
  };

  var changeHandler = function changeHandler(event) {
    setInputValue(event.target.value);
    setShowOptions(true);

    if (multiple) {
      var _filteredSuggestions = filterSelectedOptionsFromOptions(options, selectedOptions);

      var _filteredOptions = _filteredSuggestions.filter(function (option) {
        return String(getOptionLabel(option) || '').toLowerCase().includes((event.target.value || '').toLowerCase());
      });

      setFilteredSuggestions(_filteredOptions);
    } else {
      var _filteredOptions2 = options.filter(function (option) {
        return String(getOptionLabel(option) || '').toLowerCase().includes((event.target.value || '').toLowerCase());
      });

      setFilteredSuggestions(_filteredOptions2);
    }

    if (typeof onInputChange === 'function') {
      onInputChange(event, event.target.value);
    }
  };

  var selectOption = function selectOption(event, value) {
    event.preventDefault();
    setShowOptions(false);

    if (multiple) {
      setInputValue('');
      var newOptions = [].concat(_toConsumableArray(selectedOptions), [value]);
      setSelectedOptions(newOptions);
      setFilteredSuggestions(filterSelectedOptionsFromOptions(options, newOptions));
      onChange(event, newOptions);
    } else {
      setFilteredSuggestions(options);
      setInputValue(getOptionLabel(value));
      onChange(event, value);
    }
  };

  var deletePill = function deletePill(event, value) {
    var filteredOptions = selectedOptions.filter(function (item) {
      return item !== value;
    });
    setSelectedOptions(filteredOptions);
    setFilteredSuggestions(filterSelectedOptionsFromOptions(options, filteredOptions));
    onChange(event, filteredOptions);
  };

  var showSuggestions = function showSuggestions() {
    if (!(disabled || readOnly)) {
      getContainerDimension();
      setShowOptions(true);
    }
  };

  var inputClickHandler = function inputClickHandler() {
    showSuggestions();
  };

  var inputKeyDownHandler = function inputKeyDownHandler(event) {
    if (event.code === 'Enter') {
      showSuggestions();
    }
  };

  var clearAllHandler = function clearAllHandler(event) {
    if (!disabled) {
      setShowOptions(false);

      if (!multiple) {
        setInputValue('');
        onInputChange(event, '');
        return;
      }

      setFilteredSuggestions(options);
      setSelectedOptions([]);
      onChange(event, []);
    }
  };

  var crossIconClickHandler = function crossIconClickHandler(event) {
    clearAllHandler(event);
    event.stopPropagation();
  };

  var crossIconKeyDownHandler = function crossIconKeyDownHandler(event) {
    if (event.code === 'Enter') {
      clearAllHandler(event);
    }
  };

  var renderPills = function renderPills() {
    return multiple && selectedOptions.map(function (option, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-testid": "pill-wrapper",
        key: "pill-wrapper-".concat(index),
        className: _constants.classes.pillWrapper
      }, /*#__PURE__*/_react.default.createElement(_pill.default, {
        disabled: disabled,
        readOnly: readOnly,
        label: getOptionLabel(option),
        onDelete: function onDelete(event) {
          deletePill(event, option);
          event.stopPropagation();
        }
      }));
    });
  };

  var labelClasses = (_labelClasses = {}, _defineProperty(_labelClasses, _constants.classes.autocompleteLabel, true), _defineProperty(_labelClasses, _constants.classes.autocompleteLabelDisabled, disabled), _labelClasses);
  var helperTextClasses = (_helperTextClasses = {}, _defineProperty(_helperTextClasses, _constants.classes.autocompleteHelperText, true), _defineProperty(_helperTextClasses, _constants.classes.autocompleteHelperTextDisabled, disabled), _helperTextClasses);
  var containerClasses = (_containerClasses = {}, _defineProperty(_containerClasses, _constants.classes.container, multiple ? true : !readOnly), _defineProperty(_containerClasses, _constants.classes.autocompleteContainerError, !(readOnly || disabled) && multiple && error), _defineProperty(_containerClasses, _constants.classes.autocompleteSingleSelectContainerError, !(multiple || readOnly || disabled) && error), _defineProperty(_containerClasses, _constants.classes.containerDisabled, disabled), _defineProperty(_containerClasses, _constants.classes.containerReadOnly, readOnly), _defineProperty(_containerClasses, _constants.classes.autocompleteContainerFocus, !(disabled || readOnly)), _defineProperty(_containerClasses, _constants.classes.singleSelectContainer, !(multiple || readOnly)), _defineProperty(_containerClasses, _constants.classes.autocompleteSingleSelectContainerFocus, !(multiple || disabled || readOnly)), _containerClasses);
  var inputClasses = (_inputClasses = {}, _defineProperty(_inputClasses, _constants.classes.autocompleteInput, true), _defineProperty(_inputClasses, _constants.classes.autocompleteSingleSelectInput, !multiple), _defineProperty(_inputClasses, _constants.classes.autocompleteSingleSelectDisabledInput, !multiple && disabled), _inputClasses);
  var actionsContainerItemClasses = (_actionsContainerItem = {}, _defineProperty(_actionsContainerItem, _constants.classes.actionsContainerItem, true), _defineProperty(_actionsContainerItem, _constants.classes.autocompleteSingleSelectActionsContainerItem, !multiple), _defineProperty(_actionsContainerItem, _constants.classes.autocompleteActionsContainerDisabledItem, disabled), _actionsContainerItem);
  var pillInputWrapperClasses = (_pillInputWrapperClas = {}, _defineProperty(_pillInputWrapperClas, _constants.classes.autocompleteSingleSelectInputWrapper, !multiple && !readOnly), _defineProperty(_pillInputWrapperClas, _constants.classes.pillsAndInputWrapper, multiple), _pillInputWrapperClas);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.wrapper
  }, label && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, labelClasses))
  }, label), !readOnly && helperText && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, helperTextClasses))
  }, helperText), /*#__PURE__*/_react.default.createElement("div", {
    ref: autocompleteRef,
    className: (0, _classnames.default)(_objectSpread({}, containerClasses)),
    style: {
      width: width,
      height: height
    },
    tabIndex: _constants.defaultTabIndex,
    onBlur: blurHandler,
    "data-testid": _constants.classes.container,
    onClick: inputClickHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, pillInputWrapperClasses))
  }, renderPills(), multiple && !(disabled || readOnly) && /*#__PURE__*/_react.default.createElement("input", {
    className: (0, _classnames.default)(_objectSpread({}, inputClasses)),
    placeholder: placeholder,
    type: "text",
    value: inputValue,
    onChange: changeHandler,
    onClick: inputClickHandler,
    onKeyDown: inputKeyDownHandler,
    tabIndex: _constants.defaultTabIndex,
    name: name,
    onBlur: function onBlur(e) {
      return _onBlur && _onBlur(e);
    }
  }), !multiple && (!readOnly ? /*#__PURE__*/_react.default.createElement("input", {
    className: (0, _classnames.default)(_objectSpread({}, inputClasses)),
    placeholder: placeholder,
    type: "text",
    disabled: disabled,
    value: inputValue,
    onChange: changeHandler,
    onClick: inputClickHandler,
    onKeyDown: inputKeyDownHandler,
    tabIndex: _constants.defaultTabIndex,
    name: name,
    onBlur: function onBlur(e) {
      return _onBlur && _onBlur(e);
    }
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.autocompleteSingleSelectReadOnly
  }, inputValue))), !readOnly && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_constants.classes.actionsContainer, " ").concat(multiple ? _constants.classes.multipleInputActionsContainer : '')
  }, allowClearing && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, actionsContainerItemClasses)),
    onClick: crossIconClickHandler,
    onKeyDown: crossIconKeyDownHandler,
    tabIndex: _constants.defaultTabIndex
  }, (multiple && selectedOptions.length > 0 || !multiple && inputValue !== '') && /*#__PURE__*/_react.default.createElement(_fi.FiX, {
    size: _constants.defaultIconSize,
    className: disabled ? _constants.classes.autocompleteIconDisabled : _constants.classes.autocompleteIcon
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, actionsContainerItemClasses)),
    onClick: inputClickHandler,
    onKeyDown: inputKeyDownHandler,
    tabIndex: _constants.defaultTabIndex
  }, showOptions ? /*#__PURE__*/_react.default.createElement(_io.IoChevronUp, {
    size: _constants.defaultIconSize,
    className: disabled ? _constants.classes.autocompleteIconDisabled : _constants.classes.autocompleteIcon
  }) : /*#__PURE__*/_react.default.createElement(_io.IoChevronDown, {
    size: _constants.defaultIconSize,
    className: disabled ? _constants.classes.autocompleteIconDisabled : _constants.classes.autocompleteIcon
  })))), showOptions && filteredSuggestions.length > 0 && /*#__PURE__*/_react.default.createElement(_menuOptionsContainer.default, {
    portalContainerId: _constants.autocompletePortalId,
    containerDimension: containerDimension,
    width: width,
    options: multiple || !filterCurrentValueFromOptions ? filteredSuggestions : filteredSuggestions.filter(function (option) {
      return getOptionLabel(option) !== inputValue;
    }),
    onChange: selectOption,
    getOptionLabel: getOptionLabel,
    getOptionIcon: getOptionIcon,
    getOptionSublabel: getOptionSublabel,
    disablePortal: disablePortal,
    groupPropertyName: groupPropertyName
  }), error ? /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.autocompleteErrorMessage,
    style: {
      width: width
    }
  }, errorMessage) : null);
};

Autocomplete.propTypes = {
  options: _propTypes.default.array.isRequired,
  multiple: _propTypes.default.bool,
  label: _propTypes.default.string,
  helperText: _propTypes.default.string,
  onInputChange: _propTypes.default.func,
  onChange: _propTypes.default.func.isRequired,
  getOptionLabel: _propTypes.default.func.isRequired,
  getOptionSublabel: _propTypes.default.func,
  getOptionIcon: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
  width: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  error: _propTypes.default.bool,
  name: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  disablePortal: _propTypes.default.bool,
  height: _propTypes.default.string,
  allowClearing: _propTypes.default.bool,
  filterCurrentValueFromOptions: _propTypes.default.bool,
  groupPropertyName: _propTypes.default.string,
  showOptionsOnBlur: _propTypes.default.bool
};
var _default = Autocomplete;
exports.default = _default;